import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import logo from './img/logo.png';
import { trackButtonClick } from '../utils/analytics';


const Navbar = () => {

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  const navItems = [
    { name: 'Home', to: 'hero' },
    { name: 'About', to: 'about' },

    { name: 'Skills', to: 'skills' },
    { name: 'Projects', to: 'projects' },
    { name: 'Experience', to: 'experience' },
    { name: 'Contact', to: 'contact' }
  ];

  const scrollToSection = (sectionId) => {
    // Track navigation clicks
    trackButtonClick(sectionId, 'navbar');
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed top-0 w-full z-40 transition-all duration-300 ${
          scrolled 
            ? 'bg-black/90 backdrop-blur-xl border-b border-blue-500/30 shadow-lg shadow-blue-500/10' 
            : 'bg-transparent'
        }`}
      >
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
           <div className="flex flex-col md:flex-row items-center justify-between h-16">
             {/* Logo - Centered on mobile */}
             <div className="w-full md:w-auto flex justify-center md:justify-start">
               <motion.div
                 whileHover={{ scale: 1.05 }}
                 className="flex justify-center"
               >
                 <button
                    onClick={() => scrollToSection('hero')}
                    className="cursor-pointer flex items-center justify-center hover:scale-110 transition-transform duration-300"
                    aria-label="Go to home section"
                  >
                    <img src={logo} alt="Logo" className="h-16 md:h-16" />
                  </button>
               </motion.div>
             </div>

             {/* Desktop Navigation */}
             <div className="hidden md:block">
               <div className="ml-6 md:ml-10 flex items-baseline space-x-4 md:space-x-8">
                 {navItems.map((item, index) => (
                   <motion.div
                     key={item.name}
                     initial={{ opacity: 0, y: -20 }}
                     animate={{ opacity: 1, y: 0 }}
                     transition={{ delay: index * 0.1 }}
                   >
                     <button
                       onClick={() => scrollToSection(item.to)}
                       onKeyDown={(e) => {
                         if (e.key === 'Enter' || e.key === ' ') {
                           e.preventDefault();
                           scrollToSection(item.to);
                         }
                       }}
                       className="text-gray-300 hover:text-blue-400 px-2 md:px-3 py-2 rounded-md text-xs md:text-sm font-medium transition-all duration-300 cursor-pointer relative group font-mono hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 focus:bg-blue-500/10"
                       aria-label={`Navigate to ${item.name} section`}
                       tabIndex={0}
                     >
                        {item.name}
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 via-purple-400 to-emerald-400 transition-all duration-300 group-hover:w-full"></span>
                      </button>
                   </motion.div>
                 ))}
               </div>
             </div>

             
           </div>
         </div>
      </motion.nav>

      {/* Mobile Bottom Navigation - Separate Component */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-blue-500/40 shadow-2xl shadow-blue-500/20 z-[9999] pb-safe">
        <div className="flex justify-around items-center py-3 px-2">
          {navItems.map((item, index) => (
            <motion.button
              key={item.name}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollToSection(item.to)}
              className="flex flex-col items-center px-3 py-2 text-gray-300 hover:text-blue-400 transition-all duration-300 cursor-pointer rounded-xl hover:bg-blue-500/10 active:bg-blue-500/20 min-w-[50px] max-w-[80px] transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
              aria-label={`Navigate to ${item.name} section`}
              tabIndex={0}
            >
              <div className="text-[11px] sm:text-[12px] font-mono font-medium leading-tight text-center tracking-wide">{item.name}</div>
            </motion.button>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar; 